// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"4670e095","643":"c6946659","874":"596b2670","944":"cc211dea","981":"de576529","985":"42be18ff"}[chunkId] + ".chunk.js";
};